<adapt-two-column-page>
    <div left-column>
        <adapt-dashboard-element [name]="title">
            <dx-list [dataSource]="configItems"
                     [grouped]="true"
                     [collapsibleGroups]="true"
                     selectionMode="single"
                     [focusStateEnabled]="false"
                     [selectedItems]="[selectedItem]"
                     (onSelectionChanged)="onSelectionChanged($event)"
                     data-test="configuration-list">
                <div *dxTemplate="let data of 'group'">
                    <div class="list-group">{{ data.key }}</div>
                </div>
                <div *dxTemplate="let data of 'item'">
                    <div class="list-item">{{ data.name }}</div>
                </div>
            </dx-list>
        </adapt-dashboard-element>
    </div>

    <div right-column>
        @if (selectedItem) {
            <adapt-dashboard-element name="{{ selectedItem.name }}">
                @if (configurationService.shouldShowSaveButtons()) {
                    <div adapt-dashboard-title-buttons
                         adaptBlockingButtonGroup>
                        <button adaptButtonIcon="save"
                                [disabled]="!configurationService.changesAreValid()"
                                [adaptBlockingClick]="saveChanges"
                                class="btn btn-primary"
                                data-test="save-config-button">Save</button>
                        <button adaptButtonIcon="cancel"
                                [disabled]="!configurationService.hasChanges()"
                                [adaptBlockingClick]="cancelChanges">Cancel</button>
                    </div>
                }
                @if (saveError) {
                    <div role="alert"
                         class="alert alert-danger">
                        {{ saveError }}
                    </div>
                }
                <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
            </adapt-dashboard-element>
        } @else {
            <div class="card-body">Please select an area on the left to configure</div>
        }
    </div>
</adapt-two-column-page>

<ng-template #projectedContent>
    <ng-content></ng-content>
</ng-template>
